import { CustomerAccountSummaryDto, CustomerProductDto } from "@/api/models/customer";
import { CustomerBillingAccountDto } from "@/api/models/customer/customerBilling.model";

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export interface CustomerState {
	customer?: null | CustomerAccountSummaryDto;
	billing?: null | CustomerBillingAccountDto;
	customerProduct?: CustomerProductDto;
}

export const customerInitialState = () => {
	return {
		customer: null as null | CustomerAccountSummaryDto,
		billing: null as null | CustomerBillingAccountDto,
		customerProduct: {} as CustomerProductDto
	};
};

const state: CustomerState = customerInitialState();

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
